import React, { useState, useEffect } from "react";
import "./css/UpdateNotification.css";

/**
 * Listens for the `sw-update-available` custom event dispatched by
 * serviceWorkerRegistration.js and shows a toast-style banner asking the
 * user to reload for the latest version.
 *
 * The new service worker has already been told to skipWaiting(), so a simple
 * reload is all that's needed.
 */
const UpdateNotification = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleUpdate = () => setShowBanner(true);

    window.addEventListener("sw-update-available", handleUpdate);
    return () =>
      window.removeEventListener("sw-update-available", handleUpdate);
  }, []);

  if (!showBanner) return null;

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="update-notification-overlay">
      <div className="update-notification-banner">
        <div className="update-notification-content">
          <span className="update-notification-icon">🔄</span>
          <div className="update-notification-text">
            <strong>New version available!</strong>
            <p>
              KinShield has been updated. Reload to get the latest features and
              fixes.
            </p>
          </div>
        </div>
        <div className="update-notification-actions">
          <button
            className="update-notification-btn update-notification-btn-reload"
            onClick={handleReload}
          >
            Reload Now
          </button>
          <button
            className="update-notification-btn update-notification-btn-dismiss"
            onClick={() => setShowBanner(false)}
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
